import { render } from "./MoveView.vue?vue&type=template&id=14d1bc79"
import script from "./MoveView.vue?vue&type=script&lang=js"
export * from "./MoveView.vue?vue&type=script&lang=js"
script.render = render

export default script